import type * as React from "react";
import { redirect } from "next/navigation";

type BookingStepOneRedirectPageProps = {
  searchParams: Promise<Record<string, string | string[] | undefined>>;
};

const BookingStepOneRedirectPage: React.FC<
  BookingStepOneRedirectPageProps
> = async ({ searchParams }) => {
  const params = await searchParams;
  const query = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (typeof value === "string") {
      query.set(key, value);
    } else if (Array.isArray(value)) {
      value.forEach((entry) => query.append(key, entry));
    }
  }

  const destination = query.size > 0 ? `/booking?${query}` : "/booking";
  redirect(destination);
};

export default BookingStepOneRedirectPage;
